import { UserCircle } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelUserInfo = ({ customer, recipientAddress, email }) => {
  return (
    <Styles.Container>
      <UserCircle size={24} weight="light" />
      <Text type="bodyMRegular">
        {customer?.first_name} {customer?.last_name}
      </Text>
      ·<Text type="bodyMRegular">{email}</Text>
      {recipientAddress?.phone && (
        <>
          ·
          <Text type="bodyMRegular">
            +{recipientAddress?.phone?.prefix} {recipientAddress?.phone?.number}
          </Text>
        </>
      )}
    </Styles.Container>
  )
}

export default ParcelUserInfo
